import { Grid, Loader } from "@mantine/core";
import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { dataMapper } from "src/components/pages/Settings/NMEA/NMEA.utils";
import NMEACredentials from "src/components/pages/Settings/NMEA/NMEACredentials";
import NMEAMapping from "src/components/pages/Settings/NMEA/NMEAMapping/NMEAMapping";
import NMEASaveButton from "src/components/pages/Settings/NMEA/NMEASaveButton";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import { useGetApi } from "src/hooks";
import { INMEAForm } from "src/interfaces/NMEA";
import { Flex, PageContainer } from "src/styled";
import { getYachtId } from "src/utils";

const NMEA = () => {
  const methods = useForm<INMEAForm>();

  const { data, isLoading, refetch } = useGetApi({
    request: "get-nmea-config",
    body: {
      params: {
        yachtid: getYachtId(),
      },
    },
    mapper: dataMapper,
  });

  useEffect(() => {
    if (data) {
      methods.reset(data.form);
    }
  }, [data, methods]);

  return (
    <PageContainer>
      <FormProvider {...methods}>
        <Breadcrumbs>
          <Flex justify="flex-end" w="100%">
            <NMEASaveButton refetch={refetch} />
          </Flex>
        </Breadcrumbs>
        {isLoading ? (
          <Flex w="100%" h="100%" justify="center" align="center">
            <Loader />
          </Flex>
        ) : (
          <Grid columns={2} mt={20}>
            <NMEACredentials
              providers={data?.providers ?? []}
              watch={methods.watch}
            />
            <NMEAMapping
              logbooks={data?.logbooks ?? []}
              watch={methods.watch}
              disabled={!data?.isMappingAvailable}
            />
          </Grid>
        )}
      </FormProvider>
    </PageContainer>
  );
};

export default NMEA;
